import { LoggedInUser } from 'src/app/shared/store/user/user.model';

const LOCAL_STORAGE_KEY = 'PassportAuthData';

export enum LoginState {
  loggedIn = 'loggedIn',
  loggedOut = 'loggedOut',
  error = 'error',
}

export type LoginData =
  | {
      state: LoginState.loggedIn;
      user: LoggedInUser;
      token: string;
      partner: string;
    }
  | { state: LoginState.error; error: unknown; partner: string | null }
  | { state: LoginState.loggedOut; partner: string | null };

export interface PassportAuthData {
  currentPartner: string | null;
  tokens: Record<string, { token: string; expiresAt: number }>; // partner to token data
}

export const EMPTY_PASSPORT_AUTH_DATA: PassportAuthData = {
  currentPartner: null,
  tokens: {},
};

function updateCurrentPartner(
  data: PassportAuthData,
  partner: string | null,
): PassportAuthData {
  return { ...data, currentPartner: partner };
}

function updatePassportAuthToken(
  data: PassportAuthData,
  partner: string,
  tokenData: { token: string; expiresAt: number } | null,
  now: number,
): PassportAuthData {
  // Null or stale token: remove it
  if (tokenData === null || tokenData.expiresAt * 1000 < now) {
    if (!(partner in data.tokens)) {
      return data;
    }
    // Using destructuring to remove a property
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { partner: _, ...restPartners } = data.tokens;
    return { ...data, tokens: restPartners };
  }
  // Non-null token: add it
  return { ...data, tokens: { ...data.tokens, [partner]: tokenData } };
}

function savePassportAuthDataToStorage(
  data: PassportAuthData,
): PassportAuthData {
  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(data));
  return data;
}

function loadPassportAuthDataFromStorage(): PassportAuthData {
  const stored = localStorage.getItem(LOCAL_STORAGE_KEY);
  if (!stored) {
    return EMPTY_PASSPORT_AUTH_DATA;
  }
  return JSON.parse(stored);
}

export const PassportAuthData = {
  updateCurrentPartner,
  updatePassportAuthToken,
  savePassportAuthDataToStorage,
  loadPassportAuthDataFromStorage,
};
